import {Product} from './types';
import {ProposalContext} from './proposalContext';
// Explicit allowlist: no IDs, prices, URLs, internal notes or operational instructions.
export const productRewriteContext=(p:Product)=>[
  p.name,p.description,p.longDescription,...(p.features||[]),...(p.tags||[])
].filter(Boolean).join('\n');
export const proposalRewriteContext=(c:ProposalContext)=>[
  c.client,c.company,c.event,c.eventType,c.date,c.venue,c.guests,c.brief,c.objectives,c.theme,c.clientNotes,
  ...c.products.map(p=>`${p.name}: ${p.facts}`)
].filter(Boolean).join('\n');
